export const textSizes = {
  TEXT_XS: 'text-xs',
  TEXT_SM: 'text-sm',
  TEXT_BASE: 'text-base',
  TEXT_LG: 'text-lg',
  TEXT_XL: 'text-xl'
}
